module.exports = __webpack_public_path__ + "media/post-listing-block-2-overlay-wide@2x.4aca195b.webp";